import LOGO from "../../assets/images/DERMASTER_NEW_LOGO.png";
import "../../assets/styles/admin/home.scss";

const Setting = () => {
  return (
    <div className="home-page">
      <div className="center-logo">
        <img src={LOGO} />
      </div>
    </div>
  );
};
export default Setting;
